import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const MESSAGES = [
  "Mapping fintech competitors & market segment…",
  "Analysing positioning & pricing structure…",
  "Extracting feature gap matrices…",
  "Synthesizing PM product opportunities…",
  "Finalising strategic recommendations…",
];

export default function LoadingBrief({ target }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % MESSAGES.length), 2200);
    return () => clearInterval(t);
  }, []);

  return (
    <main className="flex-1 flex items-center justify-center px-4 py-24">
      <div className="w-full max-w-xl">
        <div className="text-xs font-mono tracking-widest uppercase text-slate-500 mb-4 flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-electric pulse-dot" />
          Generating brief · {target}
        </div>

        <h2 className="font-display text-2xl sm:text-3xl font-bold text-navy tracking-tight">
          Building your competitive brief
        </h2>
        <p className="mt-2 text-slate-600">Claude Sonnet 5 is analysing the fintech landscape.</p>

        <div className="mt-8 h-1.5 w-full rounded-full bg-slate-100 overflow-hidden">
          <div className="h-full w-1/2 shimmer rounded-full" />
        </div>

        <div className="mt-6 h-8 relative">
          <AnimatePresence mode="wait">
            <motion.p
              key={idx}
              data-testid="loading-status-text"
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.35 }}
              className="absolute inset-0 text-slate-700 font-medium"
            >
              {MESSAGES[idx]}
            </motion.p>
          </AnimatePresence>
        </div>

        <div className="mt-10 grid grid-cols-3 gap-3">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="h-24 rounded-lg border border-slate-200 bg-slate-50 animate-pulse"
              style={{ animationDelay: `${i * 150}ms` }}
            />
          ))}
        </div>
      </div>
    </main>
  );
}
